// Module
var code = "<input :disabled=\"$attrs.disabled || isDisabled\" :placeholder=\"placeholder\" :value=\"value\" @blur=\"emitTrimmedValue\" @change=\"emitTrimmedValue\" @focus=\"$emit('focus', $event.target)\" @input=\"$emit('input', $event.target.value)\" @keydown=\"$emit('keydown', $event)\" @keyup=\"$emit('keyup', $event.target)\"/> ";
// Exports
export default code;